import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              Latest Guides &amp; Resources
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              Expert-written articles to help you master Basetao Spreadsheet.
            </p>
          </div>
          <Link
            to="/article/what-is-basetao-spreadsheet"
            className="text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            View All Articles &rarr;
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-200 overflow-hidden"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-md text-xs font-medium text-primary-700">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading font-semibold text-foreground-900 text-sm leading-snug mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-xs leading-relaxed line-clamp-3">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-1 text-xs font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                  Read Article
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}